import { createTheme, ThemeOptions } from '@material-ui/core/styles'
import { Colors, Variables } from './export'

export const newTheme: ThemeOptions = {
  typography: {
    fontFamily: [Variables.fontFamily, 'sans-serif'].join(','),
  },
  palette: {
    primary: {
      light: Colors.colorPrimaryLight,
      main: Colors.colorPrimary,
      dark: Colors.colorPrimaryDark,
      contrastText: Colors.colorWhite,
    },
    secondary: {
      light: Colors.colorSecondaryLight,
      main: Colors.colorSecondary,
      dark: Colors.colorSecondaryDark,
      contrastText: Colors.colorPrimaryDarkestS,
    },
    success: {
      light: Colors.colorSuccessLight,
      main: Colors.colorSuccess,
      dark: Colors.colorSuccessDark,
      contrastText: Colors.colorWhite,
    },
    info: {
      light: Colors.colorInfoLight,
      main: Colors.colorInfo,
      dark: Colors.colorInfoDark,
      contrastText: Colors.colorWhite,
    },
    warning: {
      light: Colors.colorWarningLight,
      main: Colors.colorWarning,
      dark: Colors.colorWarningDark,
      contrastText: Colors.colorPrimaryDarkestS,
    },
    error: {
      light: Colors.colorDangerLight,
      main: Colors.colorDanger,
      dark: Colors.colorDangerDark,
      contrastText: Colors.colorWhite,
    },
  },
  overrides: {
    MuiPaper: {
      root: {
        color: 'inherit',
        backgroundColor: Colors.colorWhite,
      },
      rounded: { borderRadius: 8 },
    },
    MuiButton: {
      root: {
        color: Colors.colorAltHighlight,
        borderRadius: 20,
        textTransform: 'none',
        fontSize: Variables.fontSizeButton,
      },
    },
    MuiFab: {
      root: {
        color: Colors.colorAltHighlight,
        textTransform: 'none',
        fontSize: Variables.fontSizeButton,
      },
    },
    // MuiTextField: {
    //   root: {
    //     '&:before': {
    //       borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important',
    //     },
    //   },
    // },
  },
}

export const theme = createTheme(newTheme)
